import { ActionItem } from "../../types/button/ActionButton";

export const getContingencyEventTableActions = ({
  row,
  handlers,
}: {
  row: any;
  handlers: {
    onView: (id: number) => void;
  };
}): ActionItem[] => {
  return [
    {
      key: 'view',
      label: 'Ver Detalle',
      onClick: () => handlers.onView(row.id),
    },
  ];
};
